export default "__VITE_ASSET__DeUe03ht__"